import { useCallback } from 'react';

import { queryOptions, useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { LoaderCircleIcon } from 'lucide-react';

import { PageTitle } from '@components/PageTitle';
// import { Pagination } from '@components/ui/pagination';
import { EQueryKeys } from '@enums/queryKeys.enum';
import { treatmentSearchSchema } from '@schemas/treatmentSearch.schema';
import { treatmentCreatesService } from '@services/treatmentCreates/service';

import { TreatmentFilters } from '../@components/TreatmentFilters';
import { TreatmentItem } from '../@components/TreatmentItem';

const treatmentsQueryOptions = ({
  page,
  title,
}: {
  page: number;
  title?: string;
}) =>
  queryOptions({
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60,
    queryKey: [EQueryKeys.NewTreatments, page, title],
    queryFn: () =>
      treatmentCreatesService.getAllAvailable({
        page,
        title,
      }),
  });

export const Route = createFileRoute('/_layout/(private)/new-treatments/')({
  component: NewTreatments,
  validateSearch: search => treatmentSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    page: search.page,
    title: search.title,
  }),
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(
      treatmentsQueryOptions({ title: deps.title, page: deps.page }),
    );
  },
  pendingComponent: () => (
    <div className="flex min-h-dvh w-full items-center justify-center">
      <LoaderCircleIcon className="text-primary animate-spin" size={80} />
    </div>
  ),
});

function NewTreatments() {
  const navigate = Route.useNavigate();
  const { page, title } = Route.useSearch();

  const { queryClient } = Route.useRouteContext();

  const { data } = useQuery(treatmentsQueryOptions({ title, page }));

  const handleSearch = useCallback(
    (value: string) => {
      navigate({
        search: prev => ({
          ...prev,
          title: value,
        }),
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <div className="w-full space-y-3">
      <PageTitle title="Protocolos disponíveis para criação" />

      <TreatmentFilters onSubmit={handleSearch} />

      <div className="grid w-full rounded-xl border-zinc-200 bg-zinc-200 shadow">
        {data?.list.map(treatment => (
          <TreatmentItem
            key={treatment.id}
            page="/new-treatments"
            queryClient={queryClient}
            treatment={treatment}
          />
        ))}
      </div>
      {/* <Pagination
        currentPage={data?.pagination.page}
        totalPages={data?.pagination.totalPages}
      /> */}
    </div>
  );
}
